import { GET_DYNAMIC_PLANS_SUCCESS } from 'stash/actions/api';

const dynamic_platform_tiers = (state = {}, action) => {
	switch (action.type) {
		case GET_DYNAMIC_PLANS_SUCCESS:
			return action.response;
		default:
			return state;
	}
};

export default dynamic_platform_tiers;
